import { apiGet } from "./api";

// Cache simples para evitar múltiplas chamadas iguais
const objectCache = {};

// 🔹 Lista de departamentos
export async function getDepartments() {
  return apiGet("/departments");
}

// 🔹 Busca objetos pelo termo (retorna IDs)
export async function searchObjects(query) {
  if (!query || query.trim().length === 0) return null;
  return apiGet(`/search?q=${encodeURIComponent(query)}`);
}

// 🔹 Detalhes de um objeto específico (com cache)
export async function getObject(id) {
  if (!id) return null;

  if (objectCache[id]) {
    return objectCache[id];
  }

  const data = await apiGet(`/objects/${id}`);

  if (data) {
    objectCache[id] = data;
  }

  return data;
}
